import axios, { Axios } from 'axios';

const getAxios = (): Axios => {
    var baseURL: string;
    if (process.env.NODE_ENV === 'development') {
        baseURL = "http://localhost:8080";
    } else {
        baseURL = "https://api.pushcash.com";
    }
    return axios.create({
        timeout: 10000,
        baseURL,
    })
};

export default getAxios;
